import Role from '../enums/role'

export default {
  computed: {
    items () {
      let items = [
        {
          label: 'On Screen',
          icon: 'pi pi-desktop',
          to: '/on-screen'
        },
        {
          label: 'On Screen 2',
          icon: 'pi pi-desktop',
          to: '/on-screen/two'
        },
        {
          label: 'Current Motion',
          icon: 'pi pi-stopwatch',
          to: '/current-motion'
        }
      ]

      if (this.$store.getters['auth/user'].hasRole(
        [
          Role.PRESIDENT
        ]
      )) {
        items.push({
          label: 'Home',
          icon: 'pi pi-home',
          to: '/president'
        })
      }

      items.push({
        label: 'Home',
        icon: 'pi pi-home',
        to: '/president'
      })

      if (this.$store.getters['auth/user'].hasRole(
        [
          Role.OPERATOR,
          Role.ADMIN
        ]
      )) {
        items.push({
          label: 'Manage Current Motion',
          icon: 'pi pi-stopwatch',
          to: '/manage-current-motion'
        })
      }

      if (this.$store.getters['auth/user'].hasRole(
        [
          Role.OPERATOR,
          Role.ADMIN
        ]
      )) {
        items.push({
          label: 'Manage Screen',
          icon: 'pi pi-desktop',
          to: '/manage-screen'
        })
      }

      if (this.$store.getters['auth/user'].hasRole(
        [
          Role.OPERATOR,
          Role.EDITOR,
          Role.ADMIN
        ]
      )) {
        items.push({
          label: 'Cards',
          icon: 'pi pi-stopwatch',
          to: '/cards'
        })
      }

      items.push({
        label: 'Speakers',
        icon: 'pi pi-megaphone',
        to: '/speakers'
      })

      items.push({
        label: 'Ontime',
        icon: 'pi pi-megaphone',
        to: '/ontime'
      })

      /**
      if (this.$store.getters['auth/user'].hasRole(
        [
          Role.ADMIN
        ]
      )) {
        items.push({
          label: 'Settings',
          icon: 'pi pi-cog',
          to: '/settings'
        })
      }
**/
      items.push({
        label: 'Screens monitor',
        icon: 'pi pi-cog',
        to: '/screens-monitor'
      })

      items.push({
        label: 'Settings',
        icon: 'pi pi-cog',
        to: '/settings'
      })

      items.push({
        label: 'Log Out',
        icon: 'pi pi-sign-out',
        command: () => { this.logout() }
      })

      return items
    }
  },
  methods: {
    logout () {
      this.$confirm.require({
        message: 'Are you sure you want to log out?',
        header: 'Confirmation',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$store.dispatch('auth/logout')
          this.$router.push({name: 'login'})
        },
        reject: () => {

        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/handles-navigation.js